import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { SupportTicketResponse } from "../../aiTickets.types";
import { SUPPORT_TICKETS_QUERY_KEY } from "../../constants/enums";
import { ticketDetailQueryKey } from "../useGetTicket";
import { requestUpdateTicket } from "./updateTicket.request";
import { UpdateTicketBody } from "./updateTicket.types";

const useUpdateTicket = (
  options?: MutationOptions<
    SupportTicketResponse,
    ApiServiceError<ApiError>,
    UpdateTicketBody
  >,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: requestUpdateTicket,
    onError: toastServerError,
    ...options,
    onSuccess: (data, vars, ctx) => {
      // membership across Active/Resolved/All tabs + counts can change
      // (e.g. status open→resolved), so refetch every ticket list query.
      queryClient.invalidateQueries({
        queryKey: [SUPPORT_TICKETS_QUERY_KEY, "list"],
      });
      // a ticket opened through `?ticketId=` is held on its own, not in a list
      queryClient.setQueryData(ticketDetailQueryKey(vars.ticketId), data);
      options?.onSuccess?.(data, vars, ctx);
    },
  });
};

export default useUpdateTicket;
